import { TaskAltRounded } from '@mui/icons-material';
import AuthStatusPanel from 'pages/Auth/components/AuthStatusPanel';
import {
  authStatusPanelCompactDescriptionSx,
  authStatusPanelCompactTitleSx,
} from 'pages/Auth/components/AuthStatusPanel/AuthStatusPanel.styles';
import type { AuthSuccessPanelProps } from './AuthSuccessPanel.props';

const AuthSuccessPanel = ({
  description,
  extraAction,
  icon,
  mainAction,
  title,
}: AuthSuccessPanelProps) => (
  <AuthStatusPanel
    description={description}
    descriptionSx={authStatusPanelCompactDescriptionSx}
    extraAction={extraAction}
    icon={icon ?? <TaskAltRounded fontSize="large" />}
    iconBackgroundColor="success.main"
    iconColor="primary.contrastText"
    mainAction={mainAction}
    title={title}
    titleSx={[authStatusPanelCompactTitleSx, { color: 'primary.main', fontWeight: 700 }]}
  />
);

export default AuthSuccessPanel;
